import { render, staticRenderFns } from "./CPie.vue?vue&type=template&id=23f9da23"
import script from "./CPie.vue?vue&type=script&lang=js"
export * from "./CPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports